window.addEventListener("load", function() {
    const $swiperEl = $('.main-swiper');
    if (!$swiperEl.length) return;

    // Wait for swiper to be initialized
    const mainSwiper = $swiperEl[0].swiper || window.swiper;

    if (!mainSwiper) {
        console.warn("Swiper not initialized yet");
        return;
    }

    const $buttons = $('#libraryMainsite-t-float_right .list-btns a');

    // Hàm cập nhật active class cho nút tương ứng với slide
    function updateActiveButton(activeIndex) {
        $buttons.removeClass('active');
        $buttons.eq(activeIndex).addClass('active');
    }

    // Gán class active theo slide hiện tại
    updateActiveButton(mainSwiper.activeIndex);

    // Lắng nghe sự kiện đổi slide để cập nhật nút active
    mainSwiper.on('slideChange', function() {
        updateActiveButton(mainSwiper.activeIndex);
    });

    // Gán sự kiện click cho từng nút
    $buttons.each(function(index) {
        $(this).on('click', function(e) {
            e.preventDefault();
            mainSwiper.slideTo(index);
        });
    });
});